import baseQuery from "./baseQuery";
import { createApi } from "@reduxjs/toolkit/query/react";

export const compassMultiplierSettingsApi = createApi({
    reducerPath: "compassMultiplierSettingsApi",
    baseQuery: baseQuery,
    tagTypes: ["CompassMultiplierSettings"],
    endpoints: (builder) => ({
        calculateMultipliersFromCurrentStudy: builder.mutation({
            query: ({ clientName, clientRegion }) => ({
                url: `/compass_multiplier_settings/calculate_multipliers_from_current_study`,
                method: "GET",
                params: {
                    client_name: clientName,
                    client_region: clientRegion,
                },
            })
        }),
        getCurrentCompassMultipliersTableRows: builder.query({
            query: ({ clientName, clientRegion }) => ({
                url: `/compass_multiplier_settings/current_compass_multipliers_table_rows`,
                method: "GET",
                params: {
                    client_name: clientName,
                    client_region: clientRegion,
                },
            }),
            providesTags: ["CompassMultiplierSettings"],
        }),
        getCurrentCompassMultipliersTableRowOptions: builder.query({
            query: ({ clientName, clientRegion }) => ({
                url: `/compass_multiplier_settings/compass_multipliers_table_row_options`,
                method: "GET",
                params: {
                    client_name: clientName,
                    client_region: clientRegion,
                },
            }),
            // providesTags: ["CompassMultiplierSettings"],
        }),
        updateCurrentConfig: builder.mutation({
            query: ({ clientName, clientRegion, useCustomMultiplier, newMultipliers }) => ({
                url: `/compass_multiplier_settings/update_current_config`,
                method: "PUT",
                body: {
                    client_name: clientName,
                    use_custom_multiplier: useCustomMultiplier,
                    new_multipliers: newMultipliers,
                    client_region: clientRegion,
                },
            }),
            invalidatesTags: ["CompassMultiplierSettings"],
        }),
        getIsUsingCustomMultipliers: builder.query({
            query: ({ clientName, clientRegion }) => ({
                url: `/compass_multiplier_settings/is_using_custom_multipliers`,
                method: "GET",
                params: {
                    client_name: clientName,
                    client_region: clientRegion,
                },
            }),
            providesTags: ["CompassMultiplierSettings"],
        }),
    }),
});


export const {
    useCalculateMultipliersFromCurrentStudyMutation,
    useGetCurrentCompassMultipliersTableRowsQuery,
    useGetCurrentCompassMultipliersTableRowOptionsQuery,
    useUpdateCurrentConfigMutation,
    useGetIsUsingCustomMultipliersQuery,
} = compassMultiplierSettingsApi;

export default compassMultiplierSettingsApi.reducer;